import { render, staticRenderFns } from "./EnviarBolt.vue?vue&type=template&id=6497fb8b&scoped=true&"
import script from "./EnviarBolt.vue?vue&type=script&lang=js&"
export * from "./EnviarBolt.vue?vue&type=script&lang=js&"
import style0 from "./EnviarBolt.vue?vue&type=style&index=0&id=6497fb8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6497fb8b",
  null
  
)

export default component.exports